export const CommentType = [
  { id: 0, value: "Shop Finding" },
  { id: 1, value: "Work Done" },
  { id: 2, value: "Used Material" },
];
